import { render } from "./g-image-viewer.vue?vue&type=template&id=1e20455b&ts=true"
import script from "./g-image-viewer.vue?vue&type=script&lang=tsx"
export * from "./g-image-viewer.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__